import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeaturedCollectionCard({
  collection,
  index,
  resultCount
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackButtonClicked = useCallback((id, slug) => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      listingId: id,
      resultCount,
      resultIndex: index,
      resultType: 'COLLECTION',
      slug
    }));
  }, [index, resultCount, trackMarketplaceEvent]);
  return /*#__PURE__*/_jsx(SearchResultViewTracker, {
    category: collection.slug,
    collectionId: collection.id,
    listingId: collection.id,
    resultCount: resultCount,
    resultIndex: index,
    resultType: "COLLECTION",
    slug: collection.slug,
    children: /*#__PURE__*/_jsx(CollectionCard, {
      description: collection.description,
      name: collection.name,
      onClick: () => trackButtonClicked(collection.id || 0, collection.slug),
      slug: collection.slug,
      previewItems: collection.previewItems,
      totalItemCount: collection.itemCount
    })
  });
}